import { toast } from 'react-toastify';

const defaultSuccessToast = ({ message }) =>
  toast.success(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export default defaultSuccessToast;
